import React from 'react';
import _ from 'lodash'

class Days extends React.Component {
  constructor(props) {
    super()
    this.state = {
      daysArray: [],
      eventPopup: false,
      eventPopupStyles: {},
      currentEvent: {},
      overflow: false
    }
    this.makeArray = this.makeArray.bind(this)
  }

  componentDidMount() {
    this.setState({
      daysInMonth: new Date(this.props.year, this.props.month + 1, 0).getDate(),
      daysArray: this.makeArray((new Date(this.props.year, this.props.month + 1, 0).getDate()), this.props.year, this.props.month)
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      daysInMonth: new Date(nextProps.year, nextProps.month + 1, 0).getDate(),
      daysArray: this.makeArray((new Date(nextProps.year, nextProps.month + 1, 0).getDate()), nextProps.year, nextProps.month)
    })
  }

  renderDay(day,index){
    const currentDay = (this.props.selectedDate === day && this.props.selectedMonth === this.props.month && this.props.selectedYear === this.props.year)
    const events = this.props.events 
      ? this.props.events.filter((event) => { 
        return (event.year === this.props.year) && 
          (event.month === this.props.month) && 
          (event.date === day) && 
          (event.gist.type === this.props.type || this.props.type === 'All Events')
       }) 
      : []
   

    if (events.length > 0) {
      return (
        <div 
          className={`day events` + ((currentDay) ? ' current-day' : '')} 
          key={index} 
          data-day={day} 
          data-events={JSON.stringify(events)} 
          onClick={ e => (this.props.tabletView || this.props.mobile) && this.props.displayEventsMobile(e)}
        >
          {day}
          { events
            .map((event,index) =>{
              return(
                <div 
                  className="event-title" 
                  data-event={JSON.stringify(event)} 
                  onClick={ e => this.props.toggleDisplayEvents(e) } 
                  key={index}
                >
                  <p>{event.gist.title}</p>
                  { event.gist.imageGist['_1x1'] && 
                    <img alt={event.gist.title} className="event-img" src={event.gist.imageGist['_1x1']}/>
                  }
                </div>
              )
            })
          }
        </div>
      )
    }
    return(
      <div className={`day` + ((currentDay) ? ' current-day' : '') + (day === ''? ' empty': '')} key={index}>{day}</div>
    )
  }


  makeArray(num, year, month) {
    var daysArr = []
    var dateObj = new Date()
    dateObj.setDate(1)
    dateObj.setMonth(month)
    dateObj.setFullYear(year)
    var firstWeekDay = dateObj.getDay()
    for (let index = 0; index < num; index++) {
      daysArr.push(index + 1)
    }
    if (firstWeekDay !== 0) {
      for (let index = 0; index < firstWeekDay; index++) {
        daysArr.unshift("")
      }
    } else {
      daysArr.filter(day => day !== '')
    }
    return daysArr
  }

  render() {
    return (
      <div className="calendar-days">
        {this.state.daysArray
          .map((day, index) => {
            return this.renderDay(day,index)
          })
        }
      </div>
    )
  }
}

export default Days;